import Controller from '../abstracts/Controller';
import 'scss-templates/t-booking.scss';

export default class BookingController extends Controller {

  static get COMPONENTS() {
    return [
      'BookingPageComponent',
    ];
  }
}
